import React from 'react';
import RoutesClientForms from '../client';

interface Props{
    formik: any;
    id: string | undefined
}

function MultipleClientForms(props: Props) : React.ReactElement {
  const { formik, id } = props;

  const onAddAnotherClient = () => {
    formik.setFieldValue('clients', [...formik.values.clients, '']);
  };

  return (
    <div>
      {formik.values.clients.map((client: any, i: number) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i}>
          <RoutesClientForms id={id} formik={formik} client={client} isNew={!client} index={i} clients={formik.values.clients} />
        </div>
      ))}
      <button
        type="button"
        className="fz-14 fw-bold color-primary border-0 bg-transparent px-4 pt-3 ms-3"
        onClick={onAddAnotherClient}
      >
        + Add Another Client
      </button>
    </div>
  );
}

export default MultipleClientForms;
